"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReservationRequest = void 0;
var ReservationRequest = /** @class */ (function () {
    function ReservationRequest() {
    }
    return ReservationRequest;
}());
exports.ReservationRequest = ReservationRequest;
;
//# sourceMappingURL=reservation.request.js.map